export const STORE_OPTION_VALUES = {
  ALL_STORES: "ALL_STORES",
} as const;

export const STORE_CODE_VALUES = {
  ALL_STORES_CODE: "0",
} as const;

export type StoreOptionValue = typeof STORE_OPTION_VALUES[keyof typeof STORE_OPTION_VALUES];
export type StoreCodeValue = typeof STORE_CODE_VALUES[keyof typeof STORE_CODE_VALUES];
